export const nextPriority = (after, before) => {
  if (!after) return 'm';

  var codeUnit = after.charCodeAt(after.length - 1);
  var beforeCodeUnit = before?.charCodeAt(before.length - 1);
  var firstCodeUnit = 'a'.charCodeAt(0);
  var lastCodeUnit = 'z'.charCodeAt(0);
  if (before) {
    if (before.length == after.length) {
      if (beforeCodeUnit - codeUnit > 1) {
        return (
          after.substring(0, after.length - 1) +
          String.fromCharCode(codeUnit + Math.max(((beforeCodeUnit - codeUnit) / 2).toFixed(0), 1))
        );
      } else {
        return `${after}a`;
      }
    } else if (before.length > after.length) {
      if (before.charCodeAt(after.length) <= firstCodeUnit) {
        return `${after}` + String.fromCharCode(before.charCodeAt(after.length) - 1) + 'm';
      } else {
        let returnValue = after;
        let i = after.length;
        while (i < before.length && before.charCodeAt(i) <= firstCodeUnit + 1) {
          returnValue = `${returnValue}${before[i]}`;
          i++;
        }
        return (
          `${returnValue}` +
          String.fromCharCode(
            firstCodeUnit + Math.max(1, ((before.charCodeAt(i) - firstCodeUnit) / 2).toFixed(0))
          ) +
          'm'
        );
      }
    }
  }
  if (codeUnit == lastCodeUnit) {
    return `${after}m`;
  }

  return (
    after.substring(0, after.length - 1) +
    String.fromCharCode(codeUnit + Math.max(((lastCodeUnit - codeUnit) / 2).toFixed(0), 1))
  );
};
